import { render, staticRenderFns } from "./career.vue?vue&type=template&id=53c90a86&scoped=true"
import script from "./career.vue?vue&type=script&lang=js"
export * from "./career.vue?vue&type=script&lang=js"
import style0 from "./career.vue?vue&type=style&index=0&id=53c90a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c90a86",
  null
  
)

export default component.exports